export default __webpack_public_path__ + "static/flower-left-6efd8c073aae5a8faa3fd0ba5071742e.png";